import React from "react";
import { Col, Row } from "reactstrap";
import userImg from "../../../assets/images/activities/one-user.png";

const ActivityCategory = ({ onViewActivity, getFilteredActivities }) => {
  const getType = (type) => type.substring(0, type.length - 1);
  return (
    <section className="all-activities">
      <Row>
        {getFilteredActivities().activities?.map((item, index) => (
          <Col key={index} md={6} lg={3}>
            <div className="game-card">
              <div className="game-img">
                <img src={item.logo} className="img-fluid img" alt="" />
                <div className="bg-layer">
                  <h3>{item.label}</h3>
                </div>
              </div>
              <div className="game-info">
                <div className="game-info-flex">
                  <div>
                    <h4 className="text1">{item.categories[0]}</h4>
                    <div className="d-flex align-items-center">
                      <img
                        src={userImg}
                        className="img-fluid userImg1"
                        alt=""
                      />
                      <img
                        src={userImg}
                        className="img-fluid userImg me-2"
                        alt=""
                      />
                      <p className="text2">{item.players}</p>
                    </div>
                    <p className="desc">{`${
                      item.text.length > 100
                        ? item.text.substring(0, 100) + "..."
                        : item.text
                    }`}</p>
                  </div>
                  <span
                    className="view-link"
                    onClick={() =>
                      onViewActivity(
                        item,
                        getType(getFilteredActivities().label)
                      )
                    }
                  >
                    View Activity
                  </span>
                </div>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </section>
  );
};

export default ActivityCategory;
